<template>
  <v-app>
    <v-container fluid>

      <v-card>

        <v-card-title class="bg-blue-grey-lighten-4">
          Price Calculation Records
        </v-card-title>

        <v-card-text>

          <v-data-table
            :headers="headers"
            :items="getPriceCalculationList"
          >

            <template #item.index="{ index }">
              {{ ++index }}
            </template>

            <template #item.product="{ item }">
              {{ item?.inquiry_detail?.product?.name || 'N/A' }}
            </template>

            <template #item.actions="{ item }">

              <v-icon
                color="primary"
                class="me-2"
                @click="viewItem(item)"
              >
                mdi-eye
              </v-icon>

            </template>

          </v-data-table>

        </v-card-text>

      </v-card>

    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

const headers = [
  {
    title: "#SL",
    key: "index"
  },
  {
    title: "Inquiry",
    key: "price_inquiry_master_id"
  },
  {
    title: "Product",
    key: "product"
  },
  {
    title: "HS Code",
    key: "hs_code"
  },
  {
    title: "Assessment Value",
    key: "assessment_value"
  },
  {
    title: "Proposed Price",
    key: "proposed_price"
  },
  {
    title: "Actions",
    key: "actions"
  },
];

const getPriceCalculationList = computed(() => {
  return store.getters.getPriceCalculationList || [];
});

const viewItem = (item) => {

  router.push({
    name: "price-calculation-details",
    params: {
      id: item.id
    }
  });
};

onMounted(async () => {

  await store.dispatch(
    "getPriceCalculations",
    {}
  );
});
</script>
